import { useMutation } from '@apollo/client';

import { Locale } from '__generated__/graphql';

import { useAuth } from '../../common/Auth/useAuth';
import EditCurrentUserMutation from './EditCurrentUserMutation';

export const useEditLocaleHandler = () => {
  const { user } = useAuth();

  const [editLocale] = useMutation(
    EditCurrentUserMutation,
  );

  return !user ? undefined : (locale: Locale) => {
    editLocale({
      variables: {
        input: {
          locale,
        },
      },
    });
  };
};

export default undefined;
